module.exports = __webpack_public_path__ + "files/b21118c065bbcc6461e59792becf790b.png";